import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpModule, Http } from '@angular/http';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { ConfigProvider } from '../providers/config/config';
import { createTranslateLoader } from '../providers/translate/translate';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { IonicStorageModule} from '@ionic/storage';
import { Camera } from '@ionic-native/camera';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { ProductsProvider } from '../providers/products/products';
import { GoogleMaps } from '@ionic-native/google-maps';

import { LanguagePage } from '../pages/language/language';
import { SignUpPage } from '../pages/sign-up/sign-up';
import { LoginPage } from '../pages/login/login';
import { NewPricePage } from '../pages/pricing/pricing';

import { IntroPage } from '../pages/intro/intro';
import { RenewPage } from '../pages/renew_sub/renew';
import { AboutUsPage } from '../pages/about-us/about-us';
import { TechSurveyPage } from '../pages/tech-surveys/tech-surveys';
import { LeadPage } from '../pages/lead-page/lead-page';
import { AppointmentPage } from '../pages/appointment-page/appointment-page';

import { HighLevelPage } from '../pages/highlevel/highlevel';
import { NgCalendarModule  } from 'ionic2-calendar';

import { LeadDetailPage } from '../pages/lead-detail-page/lead-detail-page';

import { SingleSurveyPage } from '../pages/survey/survey';
import { CreateTechSurveyPage } from '../pages/create-tech-survey/create-tech-survey';
import { TechSurveyDetailPage } from '../pages/tech-survey-detail/tech-survey-detail';
import { PostBoilerImagePage } from '../pages/post-boiler-image/post-boiler-image';
import { RemedialSurveyPage } from '../pages/remedial-survey/remedial-survey';
import { ElevationImageReportPage } from '../pages/elevation-image-report/elevation-image-report';
import { UnderFloorImageReportPage } from '../pages/underfloor-image-report/underfloor-image-report';
import { UnderFloorInstallImageReportPage } from '../pages/underfloor-install-image-report/underfloor-install-image-report';
import { BoilerSurveyPage } from '../pages/boiler-survey/boiler-survey';

import { Geolocation } from '@ionic-native/geolocation';
import { CollectSurveyImagesPage } from '../pages/collect-survey-images/collect-survey-images';


import { ContactUsPage } from '../pages/contact-us/contact-us';
import { LoadingProvider } from '../providers/loading/loading';
import { SharedDataProvider } from '../providers/shared-data/shared-data';

import { ForgotPasswordPage } from '../pages/forgot-password/forgot-password';
import { SubscriptionsPage } from '../pages/subscriptions/subscriptions';


import { BannersComponent } from '../components/banners/banners';
import { ProductComponent } from '../components/product/product';
import { FooterComponent } from '../components/footer/footer';
//import { ComponentsModule } from '../components/components.module';
import { SlidingTabsComponent } from '../components/sliding-tabs/sliding-tabs';
import { ProductDetailPage } from '../pages/product-detail/product-detail';
import { HeaderComponent } from '../components/header/header';
import { CartPage } from '../pages/cart/cart';
import { CurencyPipe } from '../pipes/curency/curency';
import { Toast } from '@ionic-native/toast';
import { SearchPage } from '../pages/search/search';
import { AlertProvider } from '../providers/alert/alert';
import { CategoriesPage } from '../pages/categories/categories';
import { ProductsPage } from '../pages/products/products';
import { WishListPage } from '../pages/wish-list/wish-list';
import { ShippingAddressPage } from '../pages/shipping-address/shipping-address';

import { AddItemPage } from '../pages/add-item/add-item';
import { SelectCountryPage } from '../pages/select-country/select-country';
import { SelectZonesPage } from '../pages/select-zones/select-zones';
import { EmailTemplatePage } from '../pages/email-template/email-template';

import { BillingAddressPage } from '../pages/billing-address/billing-address';
import { ShippingMethodPage } from '../pages/shipping-method/shipping-method';
import { OrderPage } from '../pages/order/order';
import { SocialSharing } from '@ionic-native/social-sharing';
import { ThankYouPage } from '../pages/thank-you/thank-you';
import { CompletePage } from '../pages/complete-page/complete-page';
import { FinancePage } from '../pages/finance-offer/finance-offer';
import { Stripe } from '@ionic-native/stripe';
import { CouponProvider } from '../providers/coupon/coupon';
import { PayPal } from '@ionic-native/paypal';
import { MyAccountPage } from '../pages/my-account/my-account';
import { MyShippingAddressesPage } from '../pages/my-shipping-addresses/my-shipping-addresses';
import { EditShippingAddressPage } from '../pages/edit-shipping-address/edit-shipping-address';
import { MyOrdersPage } from '../pages/my-orders/my-orders';
import { MyFinancePage } from '../pages/my-finance/my-finance';
import { MyInstallsPage } from '../pages/my-installs/my-installs';
import { ViewSurveyPage } from '../pages/view-survey/view-survey';
import { CompleteInstallPage } from '../pages/complete-install/complete-install';
import { OrderDetailPage } from '../pages/order-detail/order-detail';
import { CreateInvoicePage } from '../pages/create-invoice/create-invoice';

import { CreateSubAccountsPage } from '../pages/create-subaccount/create-subaccount';
import { SurveyDetailPage } from '../pages/survey-detail/survey-detail';
import { NewsPage } from '../pages/news/news';
import { FinanceOptionsPage } from '../pages/finance-options/finance-options';
import { SettingsPage } from '../pages/settings/settings';
import { NewsDetailPage } from '../pages/news-detail/news-detail';
import { NewsListPage } from '../pages/news-list/news-list';
import { LocalNotifications } from '@ionic-native/local-notifications';
import { Push } from '@ionic-native/push';
import { Device } from '@ionic-native/device';
import { Facebook } from '@ionic-native/facebook';
import { GooglePlus } from '@ionic-native/google-plus';
import { Categories2Page } from '../pages/categories2/categories2';
import { SubCategoriesPage } from '../pages/sub-categories/sub-categories';
import { Home5Page } from '../pages/home5/home5';
import { PaymentsPage } from '../pages/payments/payments';
import { SubAccountsPage } from '../pages/subaccount/subaccount';
import { Home4Page } from '../pages/home4/home4';
import { Home3Page } from '../pages/home3/home3';
import { Home2Page } from '../pages/home2/home2';
import { Categories3Page } from '../pages/categories3/categories3';
import { Categories4Page } from '../pages/categories4/categories4';
import { Categories5Page } from '../pages/categories5/categories5';
import { PrivacyPolicyPage } from '../pages/privacy-policy/privacy-policy';
import { TermServicesPage } from '../pages/term-services/term-services';
import { RefundPolicyPage } from '../pages/refund-policy/refund-policy';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Network } from '@ionic-native/network';
import { SubCategories2Page } from '../pages/sub-categories2/sub-categories2';
import { SubCategories3Page } from '../pages/sub-categories3/sub-categories3';
import { SubCategories4Page } from '../pages/sub-categories4/sub-categories4';
import { SubCategories5Page } from '../pages/sub-categories5/sub-categories5';
import { Categories6Page } from '../pages/categories6/categories6';
import { SubCategories6Page } from '../pages/sub-categories6/sub-categories6';
import { RelativeTimePipe } from '../pipes/relative-time/relative-time';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { AdMobFree} from '@ionic-native/admob-free';
import { FCM } from '@ionic-native/fcm';
import { AppVersion } from '@ionic-native/app-version';
import { OneSignal } from '@ionic-native/onesignal';
import { DatePicker } from '@ionic-native/date-picker';
import { EmailComposer } from '@ionic-native/email-composer';
import { TapticEngine } from '@ionic-native/taptic-engine';
import { Pro } from '@ionic/pro';
import { Injectable, Injector } from '@angular/core';
import { GoogleAnalytics } from '@ionic-native/google-analytics';
import { InstallerPageModule } from '../pages/installer/installer.module';
import { SurveyorPageModule } from '../pages/surveyor/surveyor.module';
import { OtherPageModule } from '../pages/other/other.module';
import { SurveySelectionPageModule } from '../pages/survey-selection/survey-selection.module';
import { Deploy } from 'cordova-plugin-ionic/dist/ngx';


//Pro.init('0f59f77c', {
//  appVersion: '0'
//})

@Injectable()
export class MyErrorHandler implements ErrorHandler {
  ionicErrorHandler: IonicErrorHandler;

  constructor(injector: Injector) {
    try {
      this.ionicErrorHandler = injector.get(IonicErrorHandler);
    } catch(e) {
      // Unable to get the IonicErrorHandler provider, ensure
      // IonicErrorHandler has been added to the providers list below
    }
  }

  handleError(err: any): void {

    // Remove this if you want to disable Ionic's auto exception handling
    // in development mode.
    this.ionicErrorHandler && this.ionicErrorHandler.handleError(err);
  }
}


@NgModule({
  declarations: [
    MyApp,
    HomePage,
    SearchPage,
    CartPage,
    Home2Page,
    Home3Page,
    Home4Page,
    Home5Page,
    PaymentsPage,
    AddItemPage,
    SubAccountsPage,
    CreateSubAccountsPage,
    SearchPage,
    EmailTemplatePage,
    SubscriptionsPage,
    CategoriesPage,
    Categories2Page,
    Categories3Page,
    Categories4Page,
    Categories5Page,
    Categories6Page,
    RenewPage,
    HighLevelPage,
    SubCategoriesPage,
    SubCategories2Page,
    SubCategories3Page,
    SubCategories4Page,
    SubCategories5Page,
    SubCategories6Page,
    ProductsPage,
    RelativeTimePipe,
    LanguagePage,
    ContactUsPage,
    AboutUsPage,
    TechSurveyPage,
    SingleSurveyPage,
    PostBoilerImagePage,
    RemedialSurveyPage,
    ElevationImageReportPage,
    CollectSurveyImagesPage,
    UnderFloorImageReportPage,
    UnderFloorInstallImageReportPage,
    BoilerSurveyPage,
    LeadPage,
    AppointmentPage,
    LeadDetailPage,
    IntroPage,
    LoginPage,
		NewPricePage,
    SignUpPage,
    WishListPage,
    ShippingAddressPage,
    CreateTechSurveyPage,
    TechSurveyDetailPage,
    ForgotPasswordPage,
    HeaderComponent,
    BannersComponent,
    SelectZonesPage,
    MyShippingAddressesPage,
    BillingAddressPage,
    SelectCountryPage,
    MyAccountPage,
    ProductComponent,
    FooterComponent,
    SlidingTabsComponent,
    ProductDetailPage,
    CurencyPipe,
    ShippingMethodPage,
    ThankYouPage,
    CompletePage,
    FinancePage,
    OrderPage,
    OrderDetailPage,
    CreateInvoicePage,
    SurveyDetailPage,
    MyOrdersPage,
    MyFinancePage,
    MyInstallsPage,
    ViewSurveyPage,
    CompleteInstallPage,
    PrivacyPolicyPage,
    RefundPolicyPage,
    TermServicesPage,
    EditShippingAddressPage,
    NewsPage,
    FinanceOptionsPage,
    NewsDetailPage,
    NewsListPage,
    SettingsPage
  ],
  imports: [
    IonicModule.forRoot(MyApp,{
      backButtonText: '',
      iconMode: 'md',
    }),
    NgCalendarModule,
    HttpModule,
    BrowserModule,
    BrowserAnimationsModule,
    IonicStorageModule.forRoot(),
    LazyLoadImageModule,
    SurveySelectionPageModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [Http]
      }
    }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    Home2Page,
    Home3Page,
    Home4Page,
    Home5Page,
    SearchPage,
    PaymentsPage,
    SubAccountsPage,
    AddItemPage,
    CreateSubAccountsPage,
    CategoriesPage,
    Categories2Page,
    Categories3Page,
    Categories4Page,
    Categories5Page,
    Categories6Page,
    EmailTemplatePage,
    SubscriptionsPage,
    SubCategoriesPage,
    SubCategories2Page,
    SubCategories3Page,
    SubCategories4Page,
    SubCategories5Page,
    SubCategories6Page,
    IntroPage,
    RenewPage,
    HighLevelPage,
    PrivacyPolicyPage,
    RefundPolicyPage,
    TermServicesPage,
    LanguagePage,
    ProductsPage,
    ContactUsPage,
    AboutUsPage,
    TechSurveyPage,
    SingleSurveyPage,
    IntroPage,
    WishListPage,
    ShippingAddressPage,
    CreateTechSurveyPage,
    TechSurveyDetailPage,
    PostBoilerImagePage,
    RemedialSurveyPage,
    ElevationImageReportPage,
    CollectSurveyImagesPage,
    UnderFloorImageReportPage,
    UnderFloorInstallImageReportPage,
    BoilerSurveyPage,
    CartPage,
    LoginPage,
		NewPricePage,
    SignUpPage,
    LeadPage,
    AppointmentPage,
    LeadDetailPage,
    BillingAddressPage,
    MyShippingAddressesPage,
    SelectCountryPage,
    SelectZonesPage,
    MyAccountPage,
    ForgotPasswordPage,
    HeaderComponent,
    BannersComponent,
    ProductComponent,
    FooterComponent,
    SlidingTabsComponent,
    ProductDetailPage,
    ShippingMethodPage,
    OrderPage,
    MyOrdersPage,
    MyFinancePage,
    MyInstallsPage,
    ViewSurveyPage,
    CompleteInstallPage,
    OrderDetailPage,
    CreateInvoicePage,
    SurveyDetailPage,
    ThankYouPage,
    CompletePage,
    FinancePage,
    EditShippingAddressPage,
    NewsPage,
    FinanceOptionsPage,
    NewsDetailPage,
    NewsListPage,
    SettingsPage
  ],
  providers: [
    GoogleMaps,
    GoogleAnalytics,
    ConfigProvider,
    StatusBar,
    SplashScreen,
    SocialSharing,
    Toast,
    ConfigProvider,
    ProductsProvider,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    IonicErrorHandler,
        [{ provide: ErrorHandler, useClass: MyErrorHandler }],
    ProductsProvider,
    LoadingProvider,
    SharedDataProvider,
    Camera,
    Deploy,
    InAppBrowser,
    BarcodeScanner,
		EmailComposer,
    Stripe,
    AlertProvider,
    CouponProvider,
    PayPal,
    Push,
    Device,
    Facebook,
    GooglePlus,
    LocalNotifications,
    InAppBrowser,
    Network,
    AdMobFree,
    OneSignal,
    AppVersion,
		DatePicker,
    TapticEngine,
    Geolocation,
		FCM
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts